//TODO: check for login and connection
//TODO: flat objects for doc
// import { getFirestore, query, getDocs, collection, doc, getDoc, addDoc, deleteDoc, setDoc } from 'firebase/firestore';
import { getFirestore, query, getDocs, collection, doc, getDoc, addDoc, deleteDoc, setDoc } from './firebase.js';
import * as $ from '../thirdparty/jquery.js';
//import {$,jQuery} from '../thirdparty/jquery.js';
// import flexdatalist from '../thirdparty/flexdatalist/jquery.flexdatalist.min.js'
import htmlEditorC from './startEditor.js'
// import auth from from './auth.js'
import { fbLogger } from "./logFirebase.js";
import { downloader } from './tools.js';
import { sortIndex, filterIndexInput } from './noteIndex.js'
import * as JSZip from '../thirdparty/jszip.min.js';

export default class store {
    // mycollectionName = "testdb";
    mycollectionName = "users/#user/notes";
    tagItemList = [];
    //db: getFirestore(), //in firebase-docu only called "db"
    db;
    indexMap = {};
    sortObj = {};
    contentDoc;
    internalHtmlEditor;
    #user = "";
    constructor(uid) {
        this.#user = uid;
        this.mycollectionName = "users/" + uid + "/notes";
    }

    initFirestore() {
        if (this.#user == "") {
            alert("Please login to proceed");
            return undefined;
        }
        this.db = getFirestore();
    }

    getHtmlEditor() {
        if (typeof this.internalHtmlEditor == "undefined") {
            this.internalHtmlEditor = new htmlEditorC();
        }
        return this.internalHtmlEditor;
    }

    async docExist(docid) {
        let rV = false;
        if (docid && myapp && docid !== null) {
            if (!this.db) {
                this.initFirestore();//db = getFirestore();//in docu only called "db"
            }
            const q = query(collection(this.db, this.mycollectionName));
            const querySnapshot = await getDocs(q);
            this.indexMap = {};
            querySnapshot.forEach((doc) => {
                if (doc.id === docid) {
                    rV = true;
                }
            });
        }
        return rV;
    }

    async loadIndexlist() {
        if (myapp) {
            //this.user.uid
            if (!this.db) {
                this.initFirestore();//db = getFirestore();//in docu only called "db"
            }
            const q = query(collection(this.db, this.mycollectionName));
            const querySnapshot = await getDocs(q);
            this.indexMap = {};
            querySnapshot.forEach((doc) => {
                this.indexMap[doc.id] = doc;
            });
            this.setIndexContainer(this.indexMap);
        }
    }

    getJSONofDocument(docItem) {
        let contentJSON = {};
        try {
            if (docItem.data().doc) {
                contentJSON = JSON.parse(docItem.data().doc);
            } else {
                contentJSON = docItem.data();
            }
        } catch (error) {
            console.error(error);
        }
        contentJSON["id"] = docItem.id;
        return contentJSON;
    }

    getDateModified(contentJSON) {
        let modified = contentJSON["modified"];
        if (!modified || modified === "undefined") {
            modified = contentJSON["created"];
            if (!modified || modified === "undefined") {
                modified = new Date().toISOString();
            }
        }
        return modified;
    }

    setIndexContainer(mapOfDocs) {
        $(".indexContainer .items").empty();
        if (mapOfDocs && myapp) {
            this.sortObj = [];
            for (let key in mapOfDocs) {
                let docItem = mapOfDocs[key];
                let contentJSON = this.getJSONofDocument(docItem);
                let name = contentJSON["id"];
                if (contentJSON["name"]) {
                    name = contentJSON["name"];
                }
                let dateModified = this.getDateModified(contentJSON);
                //$(".indexContainer .items").append('<p><a href="javascript:openDocument(\''+docItem.id+'\')" class="doc btn btn-secondary btn-sm stretched-link">'+name+'</a></p>');
                // $(".indexContainer .items").append('<button onclick="mystore.openDocument(\''+docItem.id+'\')" class="btn btn-secondary btn-sm overflow-hidden w-90 text-start" type="button">'+name+'</button>');
                this.sortObj.push({
                    "id": docItem.id, "name": name, "dateModified": dateModified,
                    "value": ('<button onclick="mystore.clickEventOpen(event,this)" data-id="' + docItem.id + '" data-modified="' + dateModified + '" class="btn btn-secondary btn-sm overflow-hidden w-90 text-start" type="button">' + name + '</button>')
                });
                if (contentJSON["tags"] && contentJSON["tags"].length > 0) {
                    let tagListS = contentJSON["tags"];
                    let tagList = [];
                    if (Array.isArray(tagListS)) {
                        tagList = tagListS;
                    } else {
                        let regEx = /[\s,;]+/;
                        tagList = tagListS.split(regEx);
                    }
                    for (let tag of tagList) {
                        if (!this.tagItemList.includes(tag)) {
                            this.tagItemList.push(tag);
                        }
                    }
                }
            }
            let collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
            this.sortObj.sort((a, b) => {
                return collator.compare(a.dateModified, b.dateModified);
            }).reverse();
            for (let id in this.sortObj) {
                // console.log('bla4: ' + id);
                $(".indexContainer .items").append(this.sortObj[id].value);
            }
            //document.querySelector("#RadiosCalendar1").setAttribute("checked", "true");
            this.sortIndex();
            this.filterIndexInput();
        }
    }

    async openDocument(docId) {
        if (docId && myapp) {
            this.clearDocumentView();
            const docRef = doc(this.db, this.mycollectionName, docId);
            const docSnap = await getDoc(docRef);
            this.contentDoc = docSnap;
            //console.log(docSnap.id, " => ", docSnap.data());
            let contentJSON = this.getJSONofDocument(docSnap);
            if (contentJSON["name"] != "undefined") {
                $(".docContainer").append('<p>Documentname: <input type="text" class="contentName" value="' + contentJSON.name + '"></p>');
                //$(".docContainer .contentName").val(contentJSON.name);
                let contentRows = 20;
                if (typeof contentJSON.content === "string") {
                    if (contentJSON.content.split("\n").length > contentRows) {
                        contentRows = contentJSON.content.split("\n").length;
                    }
                }
                let modified = this.getDateModified(contentJSON);
                $(".docContainer").append("<p>Last saved: " + new Date(modified).toLocaleString() + "</p>");
                $(".docContainer").append('<div class="contentAttributes">');
                $(".contentAttributes").append('<i class="bi bi-three-dots-vertical contentAttributesMoreClick"></i><div class="contentAttributesMore"></div>');
                $(".contentAttributesMore").toggle(false);
                $(".contentAttributesMoreClick").on("click", function () { $(".contentAttributesMore").toggle(); });
                let keys = Object.keys(contentJSON);
                $(keys).each(function (index, key) {
                    if (key === "name" || key === "content") {
                        return;
                    }
                    if (key === "tags") {
                        $(".contentAttributes").prepend('<p class="">Tags: <input type="text" class="contentTags" placeholder="tags" list="contentTagList"  multiple="multiple"></p>');
                    } else {
                        $(".contentAttributesMore").append('<span>' + key + ': ' + contentJSON[key] + '<br></span>');
                    }
                });
                $(".docContainer").append('<datalist id="contentTagList"></datalist>');
                let tagItems = "";
                if (this.tagItemList && Array.isArray(this.tagItemList)) {
                    $(this.tagItemList).each(function (index, tagItem) {
                        tagItems += '<option value="' + tagItem + '">';
                    });
                }
                $("#contentTagList").append(tagItems);
                $(".docContainer").append('</div>');
                //$(".contentTags").flexdatalist();
                $(".docContainer").append('<textarea class="contentText" rows="' + contentRows + '">' + contentJSON.content + '</textarea>');
                if ($(".contentTags").length > 0) {
                    // $('.contentTags').multiselect({
                    //     includeSelectAllOption: true,
                    //     enableFiltering: true,
                    //     enableCaseInsensitiveFiltering: true,
                    //     filterPlaceholder:'Search Here..'
                    //     });
                }
            }
            if ($(".docContainer").children().length < 1) {
                $(".docContainer").append('<p>Documentname: ' + docSnap.id + '</p>');
                let keys = Object.keys(contentData);
                $(keys).each(function (index, key) {
                    $(".docContainer").append('<p>' + key + ': ' + contentData[key] + '</p>');
                });
            }
            this.setContentEvents(contentJSON);
            //<textarea class="contentName">myname</textarea><div class="contentAttributes"></div><textarea class="contentText" rows="2">StringString
            //StringString</textarea>

        }
    }

    setContentEvents(contentJSON) {
        //check for note or todo
        if (contentJSON && contentJSON["type"] == "note" && typeof this.getHtmlEditor().startEditor !== "undefined") {
            this.getHtmlEditor().startEditor('textarea.contentText');
        } else {
            //expandable textbox for contentData.contentText
            $('textarea.contentText').on('keydown input', function () {
                //Auto-expanding textarea
                this.style.removeProperty('height');
                this.style.height = (this.scrollHeight + 2) + 'px';
            }).on('mousedown focus', function () {
                //Do this on focus, to allow textarea to animate to height...
                this.style.removeProperty('height');
                this.style.height = (this.scrollHeight + 2) + 'px';
            });
        }
    }
    getDocumentContent() {
        if (this.getHtmlEditor().isActive()) {
            return this.getHtmlEditor().getHtmlContent();
        } else {
            return $(".contentText").val();
        }
    }

    async saveDocument() {
        let mydoc = {};
        let id = "";
        let reloadIndex = false;
        if (this.contentDoc && this.contentDoc.id) {
            //existing object
            id = this.contentDoc.id;
            //copy attributes
            mydoc = this.getJSONofDocument(this.contentDoc);
            let doctitle = $(".contentName").val();
            if (mydoc.name !== doctitle) {
                reloadIndex = true;
            }
            mydoc.name = doctitle;
            mydoc.content = this.getDocumentContent();
            mydoc.lastaccess = new Date().toISOString();
            mydoc.modified = new Date().toISOString();
            if ($("input.contentTags").length > 0 && $("input.contentTags")[0].value.length > 0) {
                mydoc.tags = $("input.contentTags")[0].value.split(",");
            }
            await this.saveDocIntern(id, mydoc, reloadIndex);
        } else {
            //new object
            let name = "_newDocument";
            if ($(".contentName").val()) { name = $(".contentName").val(); }
            mydoc.name = name;
            let content = this.getDocumentContent();
            if (typeof content === "undefined")
                content = "";
            mydoc.content = content;
            mydoc.lastaccess = new Date().toISOString();
            mydoc.modified = new Date().toISOString();
            mydoc.created = new Date().toISOString();
            mydoc.owner = this.#user;
            mydoc.type = "note";
            mydoc.tags = [];
            await this.saveDocIntern(null, mydoc, reloadIndex);
        }
    }

    async saveDocIntern(id, mydoc, reloadIndex, forceId) {
        if (await this.docExist(id) || (id && forceId)) {
            try {
                await setDoc(doc(this.db, this.mycollectionName, id), mydoc);
                console.log("Document successfully written!");
                this.showMessage("Saved: '" + mydoc.name + "'");
                fbLogger("saveItem", "User:'" + this.#user + "' Item:'" + id + "'");
                if (reloadIndex) {
                    this.loadIndexlist();
                }
            } catch (error) {
                console.error("Error writing document: ", error);
            }
        } else {
            try {
                let docRef = await addDoc(collection(this.db, this.mycollectionName), mydoc);
                console.log("Document written with ID: ", docRef.id);
                this.showMessage("Saved: '" + docRef.id + "'");
                fbLogger("saveItem", "User:'" + this.#user + "' Item:'" + docRef.id + "'");
                this.contentDoc = docRef;
                this.reopenSelectedDocument();
            } catch (error) {
                console.error("Error adding document: ", error);
            }
        }
    }

    reopenSelectedDocument() {
        this.loadIndexlist();
        this.openDocument(mystore.contentDoc.id);
    }

    newDocument() {
        if (this.contentDoc && this.contentDoc.id) {
            this.contentDocOld = this.contentDoc;
            this.contentDoc = undefined;
        }
        this.saveDocument();
    }

    deleteDocument() {
        if (this.contentDoc.id && this.contentDoc) {
            deleteDoc(doc(this.db, this.mycollectionName, this.contentDoc.id)).then(() => {
                console.log("Document successfully deleted!");
                this.showMessage("Deleted: '" + this.contentDoc.id + "'");
                fbLogger("saveItem", "User:'" + this.#user + "' Item:'" + this.contentDoc.id + "'");
                //clear doc view
                this.clearDocumentView();
                //reload doc index
                this.loadIndexlist();
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });
        }
    }

    clearDocumentView() {
        $(".docContainer").empty();
    }

    downloadAllDocs() {
        if (JSZip && downloader) {
            const zip = new JSZip();
            let downl = new downloader();
            for (let key in this.indexMap) {
                let doc = this.indexMap[key];
                let jdoc = this.getJSONofDocument(doc);
                zip.file(downl.cleanName(jdoc.name) + ".json", JSON.stringify(jdoc), { compression: "DEFLATE" });
            }
            zip.generateAsync({ type: "base64" }).then(function (base64) {
                window.location = "data:application/zip;base64," + base64;
            }, function (err) {
                console.log(err);
            });
        }

    }

    downloadDoc() {
        if (this.contentDoc.id && this.contentDoc && downloader) {
            let doc = this.getJSONofDocument(this.contentDoc);
            new downloader().downloadJSON(JSON.stringify(doc), doc.name);
        }
    }

    uploadDocs(selectedFile) {
        if (JSZip && selectedFile) {
            var zip = new JSZip();
            var counter = 0;
            zip.loadAsync(selectedFile).then((zip) => {
                // process ZIP file content here
                zip.forEach((relativePath, zipEntry) => {  // 2) print entries
                    counter++;
                    zipEntry.async("string").then((content) => {
                        let docJSON = JSON.parse(content);
                        this.saveDocIntern(docJSON.id, docJSON, false, true);
                        if (counter === zip.length) {
                            alert('done');
                            this.loadIndexlist();
                        }
                    });
                });
            }).error(() => { alert("Not a valid zip file") });
        }
    }

    uploadDoc() {
        // if (document.querySelector("#uploadFileDia")) {
        //     let elem = document.querySelector("#uploadFileDia");
        //     elem.parentElement.remove(elem);
        // }
        // // const inputForm = document.createElement("form");
        // const input = document.createElement("input");
        // input.tpye = "file";
        // input.id = "uploadFileDia";
        // input.style = "display:none;";
        // // inputForm.append(input);
        // document.body.append(input);
        let input = document.querySelector(".uploadFileDia");
        input.onchange = (event) => {
            if (input.files.length < 1) {
                return;
            }
            const selectedFile = input.files[0];
            console.log(selectedFile);
            if (selectedFile.name.endsWith(".zip")) {
                this.uploadDocs(selectedFile);
                return;
            }
            var reader = new FileReader();
            reader.addEventListener(
                "load",
                () => {
                    // this will then display a text file
                    // console.log(reader.result);
                    let docJSON = JSON.parse(reader.result);
                    this.saveDocIntern(docJSON.id, docJSON, true, true);
                },
                false,
            );

            if (selectedFile) {
                reader.readAsText(selectedFile);
                input.value = "";
            }
            // document.body.remove(input);
        }
        // form.onsubmit = e => {
        //     e.preventDefault();
        //     const fd = new FormData();
        //     const props = {};
        //     for (let element of form.elements) {
        //         if (element.type !== "submit") {
        //             props[element.name] = element.value;
        //             fd.append(element.name, element.value);
        //         }
        //     }

        //     for (let [key, prop] of fd) {
        //         console.log(key, prop)
        //     }

        //     const json = JSON.stringify(props);
        //     console.log(json);
        // }
        // const openFileDialog = () => {
        //     document.querySelector("#uploadFileDia").click();
        // }
        // openFileDialog();
    }

    showMessage(msg) {
        console.log(msg);
        if (tools && tools.message && tools.message.showDefault) {
            tools.message.showDefault(msg, 10);
        }
    }

    clickEventOpen(e, htmlelement) {
        //event to open a document in the contentarea or in a neq window
        console.log("open: " + e);
        let docid = "";
        if (htmlelement && htmlelement.getAttribute("data-id") && mystore) {
            docid = htmlelement.getAttribute("data-id");
            if (e && (e.shiftKey || e.ctrlKey)) {
                console.log("open page " + docid);
                let url = new URL(location.href);
                url.hash = "";
                url.search = "";
                url.searchParams.set("docid", docid);
                window.open(url, "_blank");
                return;
            }
            mystore.openDocument(docid);
        }
    }

    sortIndex(evt) {
        console.log("sort index");
        sortIndex(evt);
    }

    filterIndexInput(evt) {
        filterIndexInput(evt);
    }
};


export function loadIndex(userid, docid) {
    window.mystore = new store(userid);
    window.mystore.loadIndexlist();
    if (docid) {
        window.mystore.openDocument(docid);
    }
}


//merge mystore object
// if(window.mystore){
// window.mystore={
// ...window.mystore,
// ...mystore
// }
// }else{
// window.mystore=mystore;
// }
